import { useState } from 'react'
import { Pressable } from 'react-native'
import { Icon } from '~/components/icon'
import * as S from './index.styles'
import type { IRatingProps } from './types'

const Rating = ({
  size = 'tiny',
  value,
  ratingLimit = 5,
  onPress,
  ...rest
}: IRatingProps) => {
  const [dummyValue, setDummyValue] = useState(0)
  const IconColor = 'colorTextEvaluateDefault'

  function handlePress(index: number) {
    const ratingValue = index + 1
    onPress(ratingValue)
    setDummyValue(ratingValue)
  }

  return (
    <S.Container size={size}>
      {Array.from({ length: ratingLimit }, (_, index) => {
        const effectiveValue = value ?? dummyValue
        const integerPart = Math.floor(effectiveValue)
        const decimalPart = effectiveValue % 1
        let filledStars = integerPart
        let hasHalfStar = false

        if (decimalPart >= 0.5) {
          hasHalfStar = true
        }

        if (decimalPart >= 0.99) {
          filledStars += 1
          hasHalfStar = false
        }

        const isFullStar = index < filledStars
        const isHalfStar = index === filledStars && hasHalfStar

        return (
          <Pressable
            key={`${index}-${effectiveValue}`}
            onPress={() => handlePress(index)}
            {...rest}
            testID="star-icon"
          >
            {isFullStar ? (
              <Icon symbol="rdicon-star-filled" color={IconColor} size={size} />
            ) : isHalfStar ? (
              <Icon symbol="rdicon-star-half" color={IconColor} size={size} />
            ) : (
              <Icon
                symbol="rdicon-star-outline"
                color={IconColor}
                size={size}
              />
            )}
          </Pressable>
        )
      })}
    </S.Container>
  )
}

export { Rating, type IRatingProps }
